<template>
    <edit></edit>
</template>

<script>
    import edit from './activity_group_edit.vue'

    export default {
        name: 'activity_group_add',

        components: {
            edit
        }
    }
</script>